/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Попап 'правильно ли определен Ваш город?'
   */
  app.NotSelectedCityPopupView = app.View.extend({

    additionalOptions: ['opener'],
    events: {
      'click .js-popup-close': 'setIsSelectedCityCookie',
      'click .to-choice-wrapper': 'handleClickToChoiceButton',
    },
    /**
     * @inheritDoc
     */
    run: function () {
      this.initPopup();
      this.listenTo(this, 'toggle-not-selected-city-popup', this.toggle);
    },
    /**
     * Инициализация попапа
     */
    initPopup: function () {
      this.popup = new als.Popup(this.$el);
      this.popup.addEventListener(
        als.Popup.EventType.BEFORE_OPEN,
        (function () {
         this.setPopupPosition();
         this.$('.not-auth-city-wrapper').removeClass('not_display');
        }).bind(this)
      );
    },
    /**
     * Устанавливает положение попапа на странице
     */
    setPopupPosition: function () {
      var offset = typeof this.opener.offset === 'function' ? this.opener.offset() : null;
      if (offset) {
        this.$el.css(app.helpers.PopupPositioningHelper.positionLeftOfOpener(this.opener, this.$el));
      }
    },
    /**
     * Установка куки при подтверждении/выборе города или закрытии попапа
     */
    setIsSelectedCityCookie: function () {
      if (!app.helpers.CookieHelper.getCookie('isCitySelected')) {
        app.helpers.CookieHelper.setCookie('isCitySelected', 1, {
          domain: '.' + app.helpers.UrlHelper.getDomain(),
          path: '/',
          expires: 31536000,
        });
      }
      $('.geo-icon-city').removeClass('blink-opacity');
      this.popup.close();
    },
    /**
     * Триггерит событие для открытия попапа выбора города/валюты
     */
    handleClickToChoiceButton: function () {
      this.setIsSelectedCityCookie();
      Backbone.trigger('currencies-choice-city-popup:open', true);
    },
    /**
     * Открытие и закрытие попапа
     */
    toggle: function () {
      var isClosed = this.popup.isClosed();
      // костыль для лебедевского попапа
      setTimeout(function () {
        if (isClosed) {
          this.popup.open();
        } else {
          this.popup.close();
        }
      }.bind(this), 1);
    }
  });
})(jQuery);

}.call(window));